import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export type Bank = {
  id: string;
  name: string;
  short: string;
  sortOrder: number;
};

type BankRow = {
  id: string;
  name: string;
  short: string | null;
  sort_order: number | null;
};

function mapBank(row: BankRow): Bank {
  return {
    id: row.id,
    name: row.name,
    short: row.short ?? '',
    sortOrder: row.sort_order ?? 0,
  };
}

/**
 * Liste des banques accessibles au parcours client, stockée en base
 * et administrable depuis le back-office.
 */
export function useBanks() {
  const [banks, setBanks] = useState<Bank[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error: requestError } = await supabase
        .from('banks')
        .select('*')
        .order('sort_order', { ascending: true });
      if (requestError) throw requestError;
      setBanks((data ?? []).map((row) => mapBank(row as BankRow)));
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur de chargement des banques');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { banks, loading, error, reload: load };
}